// extracted by mini-css-extract-plugin
export default {"blockWrapper":"layout_blockWrapper__UBFDp","contentWrapper":"layout_contentWrapper__ACEyx"};